import { ListContentNode } from '@helo/cms'
import { Deferred } from '@helo/utils'

import { ListContentNodeParts } from '../../datatypes/list/listContentNode.parts'
import { type ListLoadingPreset } from '../../datatypes/list/listLayout'

const isResolvedListContentNode = (
  contentNode: unknown,
): contentNode is ListContentNode => {
  if (!contentNode || typeof contentNode !== 'object') return false

  const listNode = contentNode as ListContentNode

  return (
    listNode.kind === 'LIST' && typeof listNode.getDataTypeConfig === 'function'
  )
}

const withListLayoutState = (
  itemList: ListContentNode,
  preset: ListLoadingPreset,
) =>
  Deferred.merge({
    state: Deferred.merge({
      listDirection: 'row',
      listOptions: { preset },
    })(itemList.state ?? {}),
  })(itemList)

export const DrawerCardListContent = {
  isResolvedListContentNode,
  hasDisplayableItems: (
    itemList: ListContentNode | unknown[] | null | undefined,
  ) => {
    const itemData = ListContentNodeParts.resolveListItemData(itemList)
    return Array.isArray(itemData) && itemData.length > 0
  },
  shouldRenderFromItemList: ({
    itemList,
    listLoadingPreset,
  }: {
    itemList?: ListContentNode | unknown[] | null
    listLoadingPreset?: ListLoadingPreset
  }) => listLoadingPreset != null && itemList !== undefined,
  shouldShowListSkeleton: ({
    itemList,
    listLoadingPreset,
    isNoData,
  }: {
    itemList?: ListContentNode | unknown[] | null
    listLoadingPreset?: ListLoadingPreset
    isNoData: boolean
  }) => {
    if (!listLoadingPreset || itemList === undefined || isNoData) {
      return false
    }

    if (!DrawerCardListContent.hasDisplayableItems(itemList)) {
      return true
    }

    return !isResolvedListContentNode(itemList)
  },
  resolveListContentNode: (
    itemList: ListContentNode,
    preset: ListLoadingPreset,
  ) => withListLayoutState(itemList, preset),
  getSkeletonCount: (
    itemList: ListContentNode | unknown[] | null | undefined,
    fallback = 1,
  ) => ListContentNodeParts.getExpectedItemCount(itemList, fallback),
}
